import React from 'react'
import PropTypes from 'prop-types'
import {Text} from '@salesforce/retail-react-app/app/components/shared/ui'

export const AvailabilityBadge = ({bg = '#EC008C', callout, ...props}) => (
    <Text
        bg={bg}
        minWidth="100px"
        maxWidth="170px"
        padding="4px 12px"
        justifyContent="center"
        alignItems="center"
        color="white"
        fontSize="xs"
        fontWeight="bold"
        textTransform="uppercase"
        marginBottom="3"
        display="flex"
        lineHeight="normal"
        {...props}
    >
        {callout}
    </Text>
)

AvailabilityBadge.propTypes = {
    bg: PropTypes.string,
    callout: PropTypes.string
}
